import { fetchSpace, updateSpace } from '../../../apis';
import { get } from 'immutable';
import { generateForm } from '../../form/Form';
import { handleFormErrors } from '../../form/Form.helpers';

var dataSources = function dataSources(_ref) {
  var slug = _ref.slug;
  return {
    space: {
      fn: fetchSpace,
      params: slug && [{
        slug: slug,
        include: 'details'
      }],
      transform: function transform(result) {
        return result.space;
      }
    }
  };
};

var handleSubmit = function handleSubmit(_ref2) {
  var slug = _ref2.slug;
  return function (values) {
    return updateSpace({
      slug: slug,
      space: values
    }).then(handleFormErrors('space', 'There was an error saving the Space.'));
  };
};

var fields = function fields(_ref3) {
  var slug = _ref3.slug;
  return function (_ref4) {
    var space = _ref4.space;
    return space && [{
      name: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      initialValue: get(space, 'name', '') || ''
    }, {
      name: 'slug',
      label: 'Slug',
      type: 'text',
      required: false,
      enabled: false,
      initialValue: get(space, 'slug', '') || ''
    }, {
      name: 'sharedBundle',
      label: 'Use Shared Bundle base directory?',
      type: 'checkbox',
      "transient": true,
      initialValue: (get(space, 'sharedBundleBase') || '') !== '',
      onChange: function onChange(_ref5, _ref6) {
        var values = _ref5.values;
        var setValue = _ref6.setValue;

        if (values.get('sharedBundleBase') !== '') {
          setValue('sharedBundleBase', '');
        }

        if (values.get('bundlePath') !== '') {
          setValue('bundlePath', '');
        }
      }
    }, {
      name: 'sharedBundleBase',
      label: 'Shared Bundle Base Directory',
      type: 'text',
      initialValue: get(space, 'sharedBundleBase') || '',
      helpText: 'Directory used as path prefix for bundles.',
      visible: function visible(_ref7) {
        var values = _ref7.values;
        return values.get('sharedBundle');
      },
      required: function required(_ref8) {
        var values = _ref8.values;
        return values.get('sharedBundle');
      }
    }, {
      name: 'bundlePath',
      label: 'Bundle Path',
      type: 'text',
      initialValue: get(space, 'bundlePath') || '',
      visible: function visible(_ref9) {
        var values = _ref9.values;
        return get(values, 'sharedBundle');
      },
      required: function required(_ref10) {
        var values = _ref10.values;
        return get(values, 'sharedBundle');
      }
    }];
  };
};

export var SystemSpaceForm = generateForm({
  formOptions: ['slug'],
  dataSources: dataSources,
  fields: fields,
  handleSubmit: handleSubmit
});